export const API_STATUS = "API_STATUS";
// export const CLEAR_API_STATUS = "CLEAR_API_STATUS";
export const GET_FOLDERS_AND_FILES = "GET_FOLDERS_AND_FILES";
export const GET_FILE_URL = "GET_FILE_URL";
export const API_FILE_URL_STATUS = "API_FILE_URL_STATUS";
export const GET_FOLDERS_AND_FILES_BY_ID = "GET_FOLDERS_AND_FILES_BY_ID";
export const GET_PENDING_BATCHES_LIST = "GET_PENDING_BATCHES_LIST";
